import AccountSetting from './accountSetting';

export default AccountSetting;